
import React from "react";
import { ReactComponent as SpinnerIcon } from "../assets/spinner.svg";

const LoadingSpinner = () => {
    return <SpinnerIcon width={32} height={32} />;
  };

export default LoadingSpinner;